import { Button, Container, Heading, Link, Spacer, useColorMode } from '@chakra-ui/react';
import React from 'react';
import { Link as GLink } from 'gatsby'
import useColorTheme from '../../hooks/useColorTheme';

const Navbar = () => {
    const { colorMode, toggleColorMode } = useColorMode()
    const { gray } = useColorTheme()

    return (
        <Container alignItems={'center'} pb={'6'} px={0} display={'flex'} maxW={'container.lg'}>
            <Heading fontSize={'xl'}>
                <Link as={GLink} to="/">
                    Vong Nyuk Soon
                </Link>
            </Heading>
            <Spacer />
            {/* <Link pr={'4'} as={GLink} to="/experiences">
                Experience
            </Link>
            <Link pr={'4'} as={GLink} to="/blogs">
                Dev logs
            </Link> */}
            <Button bg={gray} w={'14'} onClick={toggleColorMode}>
                {colorMode === 'light' ? '☽' : '🌞'}
            </Button>
        </Container>
    )
};

export default Navbar;
